import { WidgetsPackageFormMain } from '@/widgets/package-form';

export const PagesPackageCreateMain = () => <WidgetsPackageFormMain mode="create" />;
